import { reduxKey } from '../../constants';
import { createAction } from 'redux-actions';
export const setDraftMessage = createAction(`${reduxKey}.DAMZ_DRAFT_SET_MSG`, (text, room_id)=>({
        text,
        room_id
    }));
export const clearDraft = createAction(`${reduxKey}.DAMZ_DRAFT_CLEAR`, (room_id)=>({
        room_id
    }));
export const addDraftAttachment = createAction(`${reduxKey}.DAMZ_DRAFT_ATTACH`, (attachment, room_id)=>({
        attachment,
        room_id
    }));
export const removeDraftAttachment = createAction(`${reduxKey}.DAMZ_DRAFT_ATTACH_REMOVE`, (room_id, index)=>({
        room_id,
        index
    }));
export const maybeUnfurlLinks = createAction(`${reduxKey}.DAMZ_DRAFT_UNFURL`, (room_id, links)=>({
        room_id,
        links
    }));
export const logUnfurlLink = createAction(`${reduxKey}.DAMZ_DRAFT_UNFURL_LOG`, (room_id, links)=>({
        room_id,
        links
    }));
export const markUnfurlResolving = createAction(`${reduxKey}.DAMZ_DRAFT_UNFURL_RESOLVE`, ()=>({}));
export const markUnfurlFinished = createAction(`${reduxKey}.DAMZ_DRAFT_UNFURL_FIN`, ()=>({}));

//# sourceMappingURL=drafts.js.map